import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    document.addEventListener('click', this.#close);
  }

  disconnect() {
    document.removeEventListener('click', this.#close);
  }

  toggle(evt) {
    evt.stopPropagation();

    this.#closeOthers();

    this.element.classList.toggle('menu-actions--open');
  }

  // Clicking outside closes the menu, so the trigger lives outside the element and cannot carry a data-action.
  #close = () => {
    this.element.classList.remove('menu-actions--open');
  };

  #closeOthers() {
    for (const menu of document.querySelectorAll('.menu-actions--open')) {
      if (menu !== this.element) menu.classList.remove('menu-actions--open');
    }
  }
}
